import styled from "@emotion/styled";
import {
  Background,
  Button,
  ITextTheme,
  TextBold,
  TextColor,
  TextLetterSpacing,
  TextLineHeight,
  TextSize,
  TextThemeContext,
} from "@ibeckinc/ui-elements";
import { useRouter } from "next/router";
import { FunctionComponent, useContext, useMemo } from "react";

import { NextLink } from "../../components/NextLink";
import { pagesPath } from "../../lib/$path";
import { device } from "../../utils";

export const SignupPromotion: FunctionComponent = () => {
  const router = useRouter();
  const textTheme = useContext(TextThemeContext);

  const signInURL = useMemo(
    () =>
      router.asPath !== "/"
        ? `${pagesPath.sign_in.$url().pathname}?callbackUrl=${router.asPath}`
        : pagesPath.sign_in.$url(),
    [router],
  );

  return (
    <Root>
      <H2 h2Theme={textTheme.h2}>会員登録して全ての内容を見る</H2>
      続きはAlternative Careers会員の方のみご覧いただけます。
      <br />
      オルタナティブキャリアは、個人の可能性最大化を実現するために、スキルアップや成長機会を支援しています。
      会員登録すると、全ての記事を閲覧できるほか、セミナーやイベントへの参加も可能です。
      <ButtonList>
        <NextLink href={signInURL}>
          <_Button color="secondary" size="small" variant="outline">
            ログイン
          </_Button>
        </NextLink>
        <NextLink href={pagesPath.sign_up.$url()}>
          <_Button size="small">会員登録</_Button>
        </NextLink>
      </ButtonList>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  margin: 0 auto;
  max-width: 720px;
  width: 100%;
`;

const H2 = styled.h2<{ h2Theme: ITextTheme }>`
  h2 {
    color: ${({ h2Theme }) => TextColor[h2Theme.color ?? "base"]};
    font-size: ${({ h2Theme }) => TextSize[h2Theme.size ?? "regular"]};
    font-weight: ${({ h2Theme }) => TextBold[h2Theme.bold ?? "bold"]};
    letter-spacing: ${({ h2Theme }) =>
      TextLetterSpacing[h2Theme.letterSpacing ?? "default"]};
    line-height: ${({ h2Theme }) =>
      TextLineHeight[h2Theme.lineHeight ?? "regular"]};
  }

  h2.article-heading-second {
    box-sizing: border-box;
    margin: 0 0 16px;
  }

  h2.article-heading-second::before {
    content: "";
    display: inline-block;
    background: ${Background.Brand};
    height: 32px;
    width: 5px;
    margin: 0px 22px -6px 0;

    @media ${device.mobile} {
      margin: 0px 16px -4px 0;
      height: 24px;
    }
  }
`;

const ButtonList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const _Button = styled(Button)`
  align-self: center;
  margin-top: 24px;
  min-width: 144px;
`;
